import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import AddOptionService from "services/addOptionService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllAddOptions = createAsyncThunk(
  "manageAddOptions/getAllAddOptions",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AddOptionService.getAllAddOptions(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const upsertAddOption = createAsyncThunk(
  "manageAddOptions/createAddOption",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await AddOptionService.upsertAddOption(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteAddOption = createAsyncThunk(
  "manageAddOptions/deleteAddOption",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await AddOptionService.deleteAddOption(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const initialState = {
  loading: false,
  addOptionList: [],
};

export const addOptionSlice = createSlice({
  name: "addOption",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAddOptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAddOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.addOptionList = action.payload;
      })
      .addCase(getAllAddOptions.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(upsertAddOption.pending, (state) => {
        state.loading = true;
      })
      .addCase(upsertAddOption.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(upsertAddOption.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteAddOption.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAddOption.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAddOption.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = addOptionSlice.actions;

export default addOptionSlice.reducer;
